import React, { useEffect, useState, useContext } from "react"
import { Modal, Label, Input } from "reactstrap"
import "../../assets/scss/manual/manual.scss";
import axios from "axios";
import AppConfig from "../../constants/config";
import * as Yup from "yup";
import { useFormik } from "formik";
import toast from 'react-hot-toast';
import { AuthContext } from "context/authContext"
import { useLocation } from "react-router-dom";

const AddGlTemplate = (prop) => {
    const location = useLocation();
    const { openPopup, toggleOpen, setOpenPopup, getGlData } = prop
    const [loading, setLoading] = useState(false);
    const { mode } = useContext(AuthContext)
    const [id, setId] = useState('');

    useEffect(() => {
        setId((location.search).replace('?', ''));
    }, [])

    const handleSubmit = async(values) => {
        setLoading(true)
        try {
            values.mode = mode
            values.client_id = id
            const {data} = await axios.post(`${AppConfig.baseUrl}/gl_template/add_gl_template`,values,{
                headers: { token: localStorage.getItem("token") }
            });
            if(!data.error){
                toast.success(data.message || 'G/L template added successfully');
                getGlData()
                formik.resetForm();
                setOpenPopup(false);
            }
            else{
                throw new Error(data.title);
            }
        } catch (error) {
            toast.error(error.message || 'Something went wrong');
        }
        setLoading(false)
    }

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            title: '',
        },
        validationSchema: Yup.object({            
            title: Yup.string().trim().required("Please Enter Title"),          
        }),
        onSubmit: handleSubmit
    });
    
    return (
        <Modal
        isOpen={openPopup}
        toggle={() => {
          toggleOpen();
          formik.resetForm();
        }}
        centered
        >
            <div className="modal-header">
            <h5 className="modal-title mt-0">Add G/L template</h5>
            <button
                type="button"
                onClick={() => {
                setOpenPopup(false);
                formik.resetForm();
                }}
                className="close"
                data-dismiss="modal"
                aria-label="Close"
            >
                <span aria-hidden="true">&times;</span>
            </button>
            </div>
            <div className="modal-body">
                <form onSubmit={formik.handleSubmit}>
                    <div className="mb-3">
                    <Label for="name" className="col-form-label">
                        Title:
                    </Label>
                    <Input
                        type="text"
                        id="title"
                        name="title"
                        className="form-control"
                        onChange={(e) => formik.setFieldValue('title',(e.target.value).replace(/\s+/g,' '))}
                        onBlur={formik.handleBlur}
                        value={formik.values.title || ""}
                    />
                    {formik.touched.title && formik.errors.title &&
                        <div className="text-danger">{formik.errors.title}</div>
                    }
                    </div>
                    <div className="modal-footer">
                        <button type="submit" className="btn btn-lbusers" disabled={loading}>
                            {
                                loading && <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i> 
                            }
                            SUBMIT
                        </button>
                    </div>
                </form>
            </div>
        </Modal>
    )
}

export default AddGlTemplate